import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PaymentIconImage from "@/components/Images/PaymentIconImage";
import OnlyAndroid from "@/components/OnlyAndroid";
import TargetBlankLink from "@/components/TargetBlankLink";
import { useCampaignApplyingRange, useExtendedTrial, useModal, usePaymentInstrumentInfoQuery, useSubscriptionEstimateQuery, useSubscriptionEstimateWithCouponLazyQuery, useValuePlanTermsQuery } from "@/hooks";
import { PAYMENT_METHOD_ID, PAYMENT_METHOD_NAMES } from "@/lib/constants";
import dayjs from "@/lib/day";
import formatPrice from "@/lib/formatPrice";
import routes from "@/lib/routes";
import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as y from "yup";
// TODO: CSSがめちゃくちゃなので直す
import { Button } from "@/components/Buttons";
import CalcTotalAmountModal from "@/components/CalcTotalAmountModal";
import CouponCodeForm from "@/components/Form/CouponCodeForm";
import { ErrorMessage, HiddenField, SingleCheckboxField } from "@/components/Form/Parts/index";
import Loading from "@/components/Loading";
import config from "@/lib/config";
import formStyles from "@/styles/Form.module.scss";
import styles from "@/styles/Payment.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function SubScriptionStep2(_ref) {
  var _valuePlanTermsData$t, _estimate$subscriptio, _estimate$subscriptio2, _estimate$subscriptio3, _estimate$subscriptio4, _errors$couponCode, _errors$valueplanTerm;
  let {
    onSubmit,
    subscriptionData,
    paymentMethodId,
    paymentInstrumentId,
    error,
    onBack
  } = _ref;
  const {
    course /*broadcastDiscount*/
  } = subscriptionData;
  const {
    showModal
  } = useModal();
  const {
    0: unappliedCouponError,
    1: setUnppliedCouponError
  } = useState();
  const {
    0: applyCampaignCode,
    1: setApplyCampaignCode
  } = useState();
  const {
    0: applyVoucherCode,
    1: setApplyVoucherCode
  } = useState();

  // react-hook-form
  const schema = useMemo(() => {
    const schema = (() => {
      const defaultSchema = {
        couponCode: y.string()
        // .length(0, "クーポンコードを適用するには適用ボタンを押してください"),
      };

      if (course.valuePlan) {
        return _objectSpread(_objectSpread({}, defaultSchema), {
          valueplanTerm: y.boolean().required("規約に同意してください。").oneOf([true], "規約に同意してください。"),
          valuePlanTermKey: y.string()
        });
      } else {
        return defaultSchema;
      }
    })();
    return y.object().shape(schema);
  }, [course]);
  const {
    register,
    handleSubmit,
    errors,
    formState,
    getValues,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    isValid,
    isSubmitting
  } = formState;
  const watchCouponCode = watch("couponCode");

  // 支払い方法
  const {
    data,
    loading
  } = usePaymentInstrumentInfoQuery({
    variables: {
      id: paymentInstrumentId
    }
  });
  const paymentInstrument = (data === null || data === void 0 ? void 0 : data.paymentInstrumentInfo) || {};
  const paymentMethod = useMemo(() => {
    if (paymentInstrument) {
      return paymentInstrument.payment_method_id;
    }
  }, [paymentInstrument]);
  const paymentIconClassName = useMemo(() => {
    return paymentMethod === PAYMENT_METHOD_ID.CREDIT_CARD_3DS ? styles.paymentCreditCardImage : styles.paymentOtherImage;
  }, [paymentMethod]);
  const creditCardInfo = useMemo(() => {
    if (paymentInstrument) {
      var _paymentInstrument$va, _paymentInstrument$va2;
      return {
        type: paymentInstrument === null || paymentInstrument === void 0 || (_paymentInstrument$va = paymentInstrument.values) === null || _paymentInstrument$va === void 0 ? void 0 : _paymentInstrument$va.card_type,
        number: `****-****-****-${paymentInstrument === null || paymentInstrument === void 0 || (_paymentInstrument$va2 = paymentInstrument.values) === null || _paymentInstrument$va2 === void 0 ? void 0 : _paymentInstrument$va2.card_number}`
      };
    }
  }, [paymentInstrument]);

  // バリュープランの規約
  const {
    data: valuePlanTermsData
  } = useValuePlanTermsQuery();
  const valuePlanTerm = valuePlanTermsData === null || valuePlanTermsData === void 0 || (_valuePlanTermsData$t = valuePlanTermsData.terms) === null || _valuePlanTermsData$t === void 0 ? void 0 : _valuePlanTermsData$t[0];

  // 契約可能か確認
  const {
    data: estimateData,
    loading: estimateLoading
  } = useSubscriptionEstimateQuery({
    variables: {
      courseId: Number(course.id),
      paymentMethodId
    },
    onCompleted: _ref2 => {
      let {
        estimate
      } = _ref2;
      if (estimate !== null && estimate !== void 0 && estimate.error) {
        // エラーの場合は前のページに戻す
        onBack(estimate.error);
      }
    }
  });
  const estimate = estimateData === null || estimateData === void 0 ? void 0 : estimateData.estimate;
  const coursePrice = formatPrice((course === null || course === void 0 ? void 0 : course.defaultPrice) || 0); // 割引が適用されていない価格
  const trialFlag = (estimate === null || estimate === void 0 || (_estimate$subscriptio = estimate.subscription) === null || _estimate$subscriptio === void 0 ? void 0 : _estimate$subscriptio.status) === "trial";
  const trialStartAt = trialFlag ? estimate === null || estimate === void 0 || (_estimate$subscriptio2 = estimate.subscription) === null || _estimate$subscriptio2 === void 0 ? void 0 : _estimate$subscriptio2.trialStartAt : null;
  const trialEndAt = trialFlag ? estimate === null || estimate === void 0 || (_estimate$subscriptio3 = estimate.subscription) === null || _estimate$subscriptio3 === void 0 ? void 0 : _estimate$subscriptio3.trialEndAt : null;

  // クーポン
  const [estimateWithCouponQuery, {
    data: estimateWithCouponData,
    loading: couponLoading
  }] = useSubscriptionEstimateWithCouponLazyQuery({
    variables: {
      courseId: Number(course.id),
      paymentMethodId
    },
    onCompleted: _ref3 => {
      let {
        estimateWithCoupon
      } = _ref3;
      const apply = {
        campaignCode: null,
        voucherCode: null
      };
      if (!(estimateWithCoupon !== null && estimateWithCoupon !== void 0 && estimateWithCoupon.error)) {
        const couponCode = getValues("couponCode");
        if (estimateWithCoupon !== null && estimateWithCoupon !== void 0 && estimateWithCoupon.campaignPrice) {
          apply.campaignCode = couponCode;
        } else if (estimateWithCoupon !== null && estimateWithCoupon !== void 0 && estimateWithCoupon.voucherCode) {
          apply.voucherCode = couponCode;
        }
      }
      setApplyCampaignCode(apply.campaignCode);
      setApplyVoucherCode(apply.voucherCode);
      setValue("couponCode", "", {
        shouldValidate: true
      });
    }
  });
  const estimateWithCoupon = estimateWithCouponData === null || estimateWithCouponData === void 0 ? void 0 : estimateWithCouponData.estimateWithCoupon;
  const campaignPrice = (estimate === null || estimate === void 0 ? void 0 : estimate.campaignPrice) || (estimateWithCoupon === null || estimateWithCoupon === void 0 ? void 0 : estimateWithCoupon.campaignPrice);
  const appliedCamapign = !!(estimate !== null && estimate !== void 0 && estimate.campaignPrice);
  const voucherCode = estimateWithCoupon === null || estimateWithCoupon === void 0 ? void 0 : estimateWithCoupon.voucherCode;

  // トライアル延長のバウチャーが適用された場合はトライアル終了日時を計算する
  // トライアルが延長された時は、初回決済日をフロント側で再計算する
  const [extendedTrialEndAt, initialTransactionAt] = useExtendedTrial(trialFlag, trialEndAt, estimate === null || estimate === void 0 || (_estimate$subscriptio4 = estimate.subscription) === null || _estimate$subscriptio4 === void 0 ? void 0 : _estimate$subscriptio4.initialTransactionAt, voucherCode);

  // トライアルがある場合は、キャンペーンの開始日時を再計算する
  // キャンペーン終了日時は、初回決済日からnヶ月後
  const [campaignStartAt, campaignEndAt] = useCampaignApplyingRange(campaignPrice === null || campaignPrice === void 0 ? void 0 : campaignPrice.campaign, initialTransactionAt, trialFlag, extendedTrialEndAt || trialEndAt);

  // // 放送契約割引キャンペーン
  // const broadcastDiscountCampaign = useMemo(() => {
  //   if (broadcastDiscount.result) {
  //     return estimate?.broadcastDiscountCampaignPrice?.campaign;
  //   }
  // }, [broadcastDiscount, estimate]);

  // // 放送契約割引の価格
  // const broadcastDiscountPrice = useMemo(() => {
  //   if (broadcastDiscount.result) {
  //     return formatPrice(
  //       estimate?.broadcastDiscountCampaignPrice.payment_amount
  //     );
  //   }
  // }, [broadcastDiscount, estimate]);

  // // 放送契約割引の適用開始日時
  // const broadcastDiscountStartAt = useMemo(() => {
  //   if (campaignEndAt) {
  //     return dayjs(new Date(campaignEndAt)).add(1, "day").format("YYYY/MM/DD");
  //   } else {
  //     return initialTransactionAt;
  //   }
  // }, [initialTransactionAt, broadcastDiscountCampaign, campaignEndAt]);

  // submitのコールバック
  const beforeSubmit = useCallback(data => {
    if (data.couponCode) {
      setUnppliedCouponError("クーポンコード入力されていますが適用されていません。\n適用ボタンを押すか、入力をクリアしてから購入するボタンを押してください。");
    } else {
      onSubmit(_objectSpread(_objectSpread({}, data), {
        applyCampaignCode,
        applyVoucherCode
      }));
    }
  }, [onSubmit, applyCampaignCode, applyVoucherCode]);

  // 前のページに戻る
  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
    }
  }, [onBack]);

  // クーポン適用
  const applyCoupon = useCallback(() => {
    const couponCode = getValues("couponCode");
    estimateWithCouponQuery({
      variables: {
        couponCode
      }
    });
  }, []);

  // クーポンの適用キャンセル
  const handleCouponCancel = useCallback(() => {
    estimateWithCouponQuery({
      variables: {
        couponCode: null
      }
    });
  }, []);

  // 年額計算のモーダルをオープン
  const handleCalcTotalAmount = useCallback(() => {
    showModal( /*#__PURE__*/_jsx(CalcTotalAmountModal, {
      initialTransactionAt: initialTransactionAt,
      pricings: estimate === null || estimate === void 0 ? void 0 : estimate.coursePricings
      //broadcastDiscountCampaign={broadcastDiscountCampaign}
      ,
      applyCamapign: campaignPrice === null || campaignPrice === void 0 ? void 0 : campaignPrice.campaign
    }), {
      style: "dialogue"
    });
  }, [estimate, initialTransactionAt,
  //broadcastDiscountCampaign,
  campaignPrice]);

  // クーポンコードのフォームが空になったら購入ボタン上のエラーメッセージをリセット
  useEffect(() => {
    if (unappliedCouponError && !watchCouponCode) {
      setUnppliedCouponError("");
    }
  }, [unappliedCouponError, watchCouponCode]);
  if (loading || estimateLoading) return null;
  if (!(estimate !== null && estimate !== void 0 && estimate.subscription)) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [couponLoading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), course.valuePlan && /*#__PURE__*/_jsx(OnlyAndroid, {
      version: 7,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.cautionSection,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.text,
          children: /*#__PURE__*/_jsxs("p", {
            children: ["\u3053\u306E\u5546\u54C1\u306F\u3054\u5229\u7528\u306E\u7AEF\u672B\uFF08Android7\u4EE5\u4E0B\uFF09\u3067\u306F\u3054\u8996\u8074\u3044\u305F\u3060\u3051\u307E\u305B\u3093\u3002", /*#__PURE__*/_jsx("br", {}), "\u3054\u8996\u8074\u306B\u306FAndroid8\u4EE5\u964D\u306E\u7AEF\u672B\u307E\u305F\u306FPC\u3001iOS\u3001\u30A2\u30D7\u30EA\u5BFE\u5FDC\u30C6\u30EC\u30D3\u304C\u5FC5\u8981\u306B\u306A\u308A\u307E\u3059\u306E\u3067 \u3054\u6CE8\u610F\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u8A73\u3057\u304F\u306F", /*#__PURE__*/_jsx(TargetBlankLink, {
              href: routes.environment,
              className: styles.link,
              children: "\u52D5\u4F5C\u74B0\u5883"
            }), "\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"]
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: `${processStyles.content} ${styles.container}`,
        children: [/*#__PURE__*/_jsx("p", {
          className: processStyles.contentHeader,
          children: "\u4E0B\u8A18\u306E\u5185\u5BB9\u3067\u8CFC\u5165\u3057\u307E\u3059\u304B\uFF1F"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.container,
          children: [/*#__PURE__*/_jsxs("div", {
            className: `${styles.section} ${styles.column} ${styles.courseInfo}`,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.table,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u5546\u54C1\u540D"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: course.name
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u91D1\u984D"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: /*#__PURE__*/_jsxs("span", {
                    className: styles.priceAmount,
                    children: [/*#__PURE__*/_jsx("span", {
                      children: "\u6708\u984D"
                    }), " ", coursePrice, "\u5186", /*#__PURE__*/_jsx("span", {
                      children: "\uFF08\u7A0E\u8FBC\uFF09"
                    })]
                  })
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u652F\u6255\u65B9\u6CD5"
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.value,
                  children: [/*#__PURE__*/_jsx("div", {
                    children: PAYMENT_METHOD_NAMES[paymentMethod]
                  }), (paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD_3DS || paymentMethod == PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS) && /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx(PaymentIconImage, {
                      paymentMethodId: paymentMethod,
                      cardType: creditCardInfo.type,
                      className: paymentIconClassName
                    }), /*#__PURE__*/_jsx("span", {
                      children: creditCardInfo.number
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u521D\u56DE\u6C7A\u6E08\u65E5"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: initialTransactionAt
                })]
              })]
            }), /*#__PURE__*/_jsxs("ul", {
              className: styles.attentionNote,
              children: [/*#__PURE__*/_jsx("li", {
                children: "\u203B \u4EE5\u964D\u6BCE\u6708\u540C\u65E5\u306B\u6C7A\u6E08\u3068\u306A\u308A\u307E\u3059\u3002"
              }), /*#__PURE__*/_jsx("li", {
                children: "\u203B 29\u65E5\u300130\u65E5\u300131\u65E5\u306B\u3054\u8CFC\u5165\u306E\u5834\u5408\u306F\u7FCC\u6708\u672B\u304C\u6C7A\u6E08\u65E5\u3068\u306A\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002"
              }), /*#__PURE__*/_jsx("li", {
                children: "\u203B \u5F15\u304D\u843D\u3068\u3057\u65E5\u306F\u5404\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u4F1A\u793E\u3001\u6C7A\u6E08\u30B5\u30FC\u30D3\u30B9\u3054\u3068\u306B\u7570\u306A\u308A\u307E\u3059\u3002"
              })]
            })]
          }), trialFlag && /*#__PURE__*/_jsxs("div", {
            className: `${styles.section} ${styles.column} ${styles.trialInfo}`,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.header,
              children: course.trialText
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.table,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u9069\u7528\u671F\u9593"
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.value,
                  children: [trialStartAt, " \u301C ", !extendedTrialEndAt && trialEndAt, extendedTrialEndAt && /*#__PURE__*/_jsxs("span", {
                    children: [/*#__PURE__*/_jsx("span", {
                      className: styles.lineThrough,
                      children: trialEndAt
                    }), " ", extendedTrialEndAt]
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u91D1\u984D"
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.value,
                  children: ["\u7121\u6599\uFF08", course.trialCampaignFlag ? course.trialText : "トライアル", "\uFF09"]
                })]
              })]
            }), extendedTrialEndAt && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("a", {
                className: styles.couponCancelLink,
                onClick: handleCouponCancel,
                children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u5EF6\u9577\u306E\u9069\u7528\u3092\u89E3\u9664\u3059\u308B"
              })
            })]
          }), campaignPrice && /*#__PURE__*/_jsxs("div", {
            className: `${styles.section} ${styles.column}`,
            children: [trialFlag && /*#__PURE__*/_jsxs("div", {
              children: [course.trialCampaignFlag ? "キャンペーン" : "トライアル", "\u671F\u9593\u7D42\u4E86\u5F8C"]
            }), /*#__PURE__*/_jsx("div", {
              className: styles.header,
              children: campaignPrice.campaign.name
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.table,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u9069\u7528\u671F\u9593"
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.value,
                  children: [campaignStartAt, " \u301C ", campaignEndAt]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.row,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.label,
                  children: "\u91D1\u984D"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.value,
                  children: /*#__PURE__*/_jsxs("span", {
                    className: styles.priceAmount,
                    children: [/*#__PURE__*/_jsx("span", {
                      children: "\u6708\u984D"
                    }), " ", formatPrice(campaignPrice.payment_amount), "\u5186", /*#__PURE__*/_jsx("span", {
                      children: "\uFF08\u7A0E\u8FBC\uFF09"
                    })]
                  })
                })]
              })]
            }), !appliedCamapign && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("a", {
                className: styles.couponCancelLink,
                onClick: handleCouponCancel,
                children: "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u306E\u9069\u7528\u3092\u89E3\u9664\u3059\u308B"
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs("ul", {
          className: styles.attentionNote,
          children: [/*#__PURE__*/_jsx("li", {
            children: "\u5951\u7D04\u671F\u9593\u4E2D\u306F\u3001\u5546\u54C1\u306B\u5185\u5305\u3055\u308C\u308B\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u8996\u8074\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
          }), trialFlag && /*#__PURE__*/_jsxs("li", {
            children: [course.trialText, "\u671F\u9593\u7D42\u4E86\u5F8C\u306F\u3001\u3054\u89E3\u7D04\u3044\u305F\u3060\u304F\u307E\u3067\u306F\u5546\u54C1\u306E\u8CA9\u58F2\u7D42\u4E86\u65E5\u307E\u30671\u30F6\u6708\u3054\u3068\u306B\u81EA\u52D5\u7684\u306B\u66F4\u65B0\u3055\u308C\u307E\u3059\u3002"]
          }), /*#__PURE__*/_jsxs("li", {
            children: ["1\u5E74\u3054\u5951\u7D04\u7D99\u7D9A\u6642\u306E\u7DCF\u984D\u306F", /*#__PURE__*/_jsx("a", {
              className: styles.accentColoelink,
              onClick: handleCalcTotalAmount,
              children: "\u3053\u3061\u3089"
            })]
          })]
        })]
      })
    }), error && /*#__PURE__*/_jsx("div", {
      className: styles.creditCardError,
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        msg: error
      })
    }), /*#__PURE__*/_jsx(CouponCodeForm, {
      enable: !applyCampaignCode && !applyVoucherCode,
      register: register,
      apply: applyCoupon,
      error: (estimateWithCoupon === null || estimateWithCoupon === void 0 ? void 0 : estimateWithCoupon.error) || (errors === null || errors === void 0 || (_errors$couponCode = errors.couponCode) === null || _errors$couponCode === void 0 ? void 0 : _errors$couponCode.message)
    }), /*#__PURE__*/_jsxs("div", {
      className: formStyles.guideArea,
      children: [/*#__PURE__*/_jsxs("p", {
        children: ["\u89E3\u7D04\u306B\u3064\u3044\u3066", /*#__PURE__*/_jsx("br", {}), "\u6708\u984D\u5546\u54C1\u306E\u89E3\u7D04\u306F\u3001\u5951\u7D04\u671F\u9593\u306E\u6E80\u4E86\u3059\u308B24\u6642\u9593\u524D\u307E\u3067\u306B \u30A2\u30AB\u30A6\u30F3\u30C8\u30DA\u30FC\u30B8\uFF1E\u3054\u5229\u7528\u72B6\u6CC1 \u304B\u3089\u304A\u624B\u7D9A\u304D\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "\u5546\u54C1\u306E\u6027\u8CEA\u4E0A\u3001\u6C7A\u6E08\u5B8C\u4E86\u5F8C\u306E\u30AD\u30E3\u30F3\u30BB\u30EB\u3084\u8FD4\u91D1\u7B49\u306B\u306F\u5FDC\u3058\u3089\u308C\u307E\u305B\u3093\u3002"]
      }), trialFlag && /*#__PURE__*/_jsxs("p", {
        children: [course.trialText, "\u671F\u9593\u4E2D\u306B\u89E3\u7D04\u3055\u308C\u305F\u5834\u5408\u3001", course.trialText, "\u671F\u9593\u304C\u6B8B\u3063\u3066\u3044\u3066\u3082\u5373\u65E5\u3054\u8996\u8074\u3044\u305F\u3060\u3051\u306A\u304F\u306A\u308A\u307E\u3059\u3002"]
      })]
    }), /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit(beforeSubmit),
      noValidate: true,
      children: [course.valuePlan && valuePlanTerm && /*#__PURE__*/_jsxs("div", {
        className: formStyles.guideArea,
        children: [/*#__PURE__*/_jsx(SingleCheckboxField, {
          ref: register,
          title: "\u3053\u306E\u5546\u54C1\u306E\u8CFC\u5165\u306B\u306F\u898F\u7D04\u306E\u540C\u610F\u304C\u5FC5\u8981\u3067\u3059\u3002",
          name: "valueplanTerm",
          defaultChecked: false,
          label: /*#__PURE__*/_jsxs("p", {
            className: formStyles.terms,
            children: [/*#__PURE__*/_jsx(TargetBlankLink, {
              href: valuePlanTerm.current_revision.url,
              children: valuePlanTerm.display_name
            }), "\u306B\u540C\u610F\u3059\u308B"]
          }),
          error: errors === null || errors === void 0 || (_errors$valueplanTerm = errors.valueplanTerm) === null || _errors$valueplanTerm === void 0 ? void 0 : _errors$valueplanTerm.message
        }), /*#__PURE__*/_jsx(HiddenField, {
          ref: register,
          name: "valuePlanTermKey",
          value: valuePlanTerm.current_revision.unique_key
        }), /*#__PURE__*/_jsxs("p", {
          className: formStyles.caption,
          children: ["\u300E", config.valuePlan.text, "\u300F\u3054\u5229\u7528\u8005\u69D8\u306E\u500B\u4EBA\u60C5\u5831\u306F\u3001\u682A\u5F0F\u4F1A\u793ENTT\u30C9\u30B3\u30E2\u3068\u30B9\u30AB\u30D1\u30FCJSAT\u682A\u5F0F\u4F1A\u793E\u3067\u5171\u540C\u5229\u7528\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002\u8A73\u3057\u304F\u306F", /*#__PURE__*/_jsx(TargetBlankLink, {
            href: "/static/legal/valueplan_sharing_item",
            className: formStyles.textLink,
            children: "\u3053\u3061\u3089"
          }), "\u3092\u3054\u78BA\u8A8D\u4E0B\u3055\u3044\u3002"]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: formStyles.btnArea,
        children: [/*#__PURE__*/_jsx(ErrorMessage, {
          msg: unappliedCouponError
        }), /*#__PURE__*/_jsxs(Button, {
          type: "submit",
          fillColor: true,
          fontFixed: true,
          large: true,
          disabled: !isValid,
          loading: isSubmitting,
          children: [course.valuePlan && trialFlag && /*#__PURE__*/_jsxs(_Fragment, {
            children: [course.trialTermText, "\u3092\u5229\u7528\u3057\u3066"]
          }), "\u8CFC\u5165\u3059\u308B"]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.backButton,
          children: /*#__PURE__*/_jsx("a", {
            onClick: handleBack,
            children: "\u524D\u306E\u753B\u9762\u3078\u623B\u308B"
          })
        })]
      })]
    })]
  });
}